module.exports = __webpack_public_path__ + "static/media/robot-eureka.6591b640.svg";